import React from "react";
import { useFavorites } from "../context/FavoritesContext";
// import { useNavigate } from "react-router-dom";
import BreweryItem from "../components/BreweryItem";

const FavoritesPage = () => {
    const { favorites } = useFavorites();
    // const navigate = useNavigate();

    // const handleRedirect = state => {
    //     navigate(`/state/${state}`);
    // };

    if (favorites.length === 0) {
        return (
            <div>
            <h2>Favorite Breweries</h2>
            <p>No favorite breweries yet.</p>
            </div>
        );
    }

    return (
        <div>
            <h2>Favorite Breweries</h2>
            <ul className="list-group">
                {favorites.map(brewery => (
                    <BreweryItem key={brewery.id} brewery={brewery} showStateButton />
                ))}
            </ul>
        </div>
    );
};

export default FavoritesPage;
